import { useRef } from 'react';
import { Haptics } from '@capacitor/haptics';

/**
 * Custom hook for throttled haptic feedback
 * Prevents app crashes from rapid haptic calls by limiting frequency
 * 
 * @param throttleMs - Minimum milliseconds between haptic calls (default: 100ms = 10 haptics/second)
 * @returns Function to trigger throttled haptic feedback
 */
export function useThrottledHaptics(throttleMs = 100) {
  const lastHapticTimeRef = useRef<number>(0);

  const vibrate = (duration = 10) => {
    const now = Date.now();
    if (now - lastHapticTimeRef.current > throttleMs) {
      lastHapticTimeRef.current = now;
      Haptics.vibrate({ duration }).catch(() => {
        // Silently catch haptic errors to prevent crashes
      });
    }
  };

  return vibrate;
}

